import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';
import { decorateRegionalPerformance } from '../lib/proxyviews-seo';

export default class ProxyviewsGeoCityRoute extends DiscourseRoute {
  async model(params) {
    const data = await ajax(`/proxies/${params.country}/${params.city}.json`);
    const providers = (data.providers || []).map((p, i) => ({
      ...p,
      rank: i + 1,
      ratingDisplay: p.overall_rating ? Number(p.overall_rating).toFixed(1) : '—',
      costDisplay: (p.price_range || p.real_cost_per_gb) ? `$${p.price_range || p.real_cost_per_gb}/GB` : '—',
      logoInitial: (p.name || '?').charAt(0).toUpperCase(),
      url: `/providers/${p.slug}`,
      ...decorateRegionalPerformance(p.regional_performance),
    }));
    return {
      city: data.city,
      location: data.location,
      title: data.title,
      metaTitle: data.meta_title,
      providers,
    };
  }

  titleToken() {
    return this.currentModel?.metaTitle || 'Best Proxies';
  }
}
